/* TEN-FOUR cover plate builder (shop-v1).
   Reads its data from <script type="application/json" data-cpb-data> inside each [data-cpb] root:
     sizes      ["4U", ...]                       rack heights on offer
     variants   [{id, o:[size, panel, style], price (cents), available}]   "Cover Plate Panel" product
     sets       [{id, size, price (cents), available}]                     standard set product (optional)
     setDiscountPct  10 (custom full set, applied by an automatic discount in the cart; 0 = off)
     defaultSize, cartUrl, currency
     viewOnly   true on the 3D viewer page: no prices, totals or add to cart, rack specs instead
     mediaOnly  true on the rack page's image column: the 3D rack alone (no plates, no form); once it loads it
                moves into mediaTarget and hides what was there. frame = "Black" | "Silver" to start with
     owner      (local preview only) {cost:{"8U|top|vented": 29.76}, cnc:{...}, A:{assumptions}}
   Same file runs in the theme section and in the local preview page. */
(function () {
  const PANELS = [
    { key: "top", label: "Top", vent: true, def: "vented", note: "Honeycomb vent and screw holes for an 80 mm fan, or plain." },
    { key: "bottom", label: "Bottom", vent: true, def: "plain", note: "Vent it to pull cool air in from underneath." },
    { key: "side-left", label: "Left side", vent: true, def: "plain", note: "Carries the laser-etched NBHT logo." },
    { key: "side-right", label: "Right side", vent: true, def: "plain", note: "Vent sits high up to let warm air out." },
    { key: "rear", label: "Rear", vent: true, def: "plain", note: "Two 70 mm cable holes with rubber grommets. Vent adds a fan above them." },
    { key: "front-surround", label: "Front surround", vent: false, def: "plain", note: "Frames the rails. Every U stays usable." },
  ];
  const STYLE_NAME = { plain: "Plain", vented: "Vented" };
  // Powder colours: PPCCO basic colours under $62 (cover-plates/shop-v1/powder-colours-v1.json). Hex is an on-screen estimate.
  const COLOURS = [{"name":"Satin Black","hex":"#151619","finish":"satin"},{"name":"Semi Gloss Black","hex":"#121315","finish":"semi"},{"name":"Jet High Gloss Black","hex":"#0d0d0f","finish":"gloss"},{"name":"Mirror Black","hex":"#0a0a0b","finish":"mirror"},{"name":"Flat Black","hex":"#18191b","finish":"flat"},{"name":"Dark Grey Battleship","hex":"#4a4f55","finish":"gloss"},{"name":"Machine Grey","hex":"#8a8a84","finish":"gloss"},{"name":"Squirrel Gray","hex":"#8e9192","finish":"gloss"},{"name":"Blue Gray","hex":"#6b7d8e","finish":"gloss"},{"name":"Periwinkle Grey","hex":"#9aa3c0","finish":"gloss"},{"name":"Signal White","hex":"#f1f0ea","finish":"gloss"},{"name":"Appliance White","hex":"#f4f4f0","finish":"gloss"},{"name":"Off White","hex":"#ece8dc","finish":"gloss"},{"name":"Cream","hex":"#efe3c2","finish":"gloss"},{"name":"Beige","hex":"#d6c4a0","finish":"gloss"},{"name":"Signal Red","hex":"#9b1b1e","finish":"gloss"},{"name":"Wagon Red","hex":"#b21f24","finish":"gloss"},{"name":"Mirror Red","hex":"#c0161b","finish":"mirror"},{"name":"MG Maroon","hex":"#5e1a22","finish":"gloss"},{"name":"Bright Pink","hex":"#e5508f","finish":"gloss"},{"name":"Light Violet","hex":"#a68fc9","finish":"gloss"},{"name":"Powder Orange","hex":"#e8601c","finish":"gloss"},{"name":"Chevy Orange","hex":"#e2541b","finish":"gloss"},{"name":"Orange Yellow","hex":"#f3a400","finish":"gloss"},{"name":"Bird Yellow","hex":"#f7d117","finish":"gloss"},{"name":"Mirror Yellow","hex":"#f2c500","finish":"mirror"},{"name":"Lime Green","hex":"#6fbe2e","finish":"gloss"},{"name":"Medium Green","hex":"#2f7d3a","finish":"gloss"},{"name":"Dark Green","hex":"#1f4a2c","finish":"gloss"},{"name":"Olive Drab Green","hex":"#4b5320","finish":"satin"},{"name":"Sea Foam Green","hex":"#8fd3b6","finish":"gloss"},{"name":"Turquoise Blue","hex":"#1f9fae","finish":"gloss"},{"name":"Pastel Blue","hex":"#a9c8e6","finish":"gloss"},{"name":"Ford Light Blue","hex":"#5d8fc7","finish":"gloss"},{"name":"Cadillac Blue","hex":"#3a5f8f","finish":"gloss"},{"name":"Mirror Blue","hex":"#1546a8","finish":"mirror"},{"name":"Ford Dark Blue","hex":"#1f3a6e","finish":"gloss"},{"name":"Navy Blue","hex":"#1c2a4a","finish":"gloss"}];
  const FINISH = {   // gloss level -> look: roughness of the base coat and a clear-coat layer for the shine
    mirror: { label: "Mirror gloss", roughness: 0.18, clearcoat: 1, clearcoatRoughness: 0.03 },
    gloss: { label: "High gloss", roughness: 0.3, clearcoat: 0.8, clearcoatRoughness: 0.08 },
    semi: { label: "Semi-gloss", roughness: 0.4, clearcoat: 0.45, clearcoatRoughness: 0.22 },
    satin: { label: "Satin", roughness: 0.55, clearcoat: 0.15, clearcoatRoughness: 0.45 },
    flat: { label: "Flat", roughness: 0.9, clearcoat: 0, clearcoatRoughness: 1 },
  };
  const FRAME_H = { "4U": 225.2, "6U": 314.1, "8U": 403, "10U": 491.9, "12U": 580.8 };
  // outside height, rail length and holes per rail (same figures as the old ten-four-viewer section)
  const RACK = { "4U": [235.2, 177.2, 12], "6U": [324.1, 266.1, 18], "8U": [413, 355, 24], "10U": [501.9, 443.9, 30], "12U": [590.8, 532.8, 36] };

  function dims(size) {            // flat plate sizes in mm (v5 rule)
    const H = FRAME_H[size];
    return { top: [305.525, 301.525], bottom: [305.525, 301.525], "side-left": [301.525, H + 3],
      "side-right": [301.525, H + 3], rear: [305.525, H + 7], "front-surround": [305.525, H + 7] };
  }

  function init(root) {
    const D = JSON.parse(root.querySelector("[data-cpb-data]").textContent);
    const VIEW = !!D.viewOnly, MEDIA = !!D.mediaOnly;
    if (MEDIA) root.classList.add("cpb--media");
    const V = {};
    D.variants.forEach(v => { V[v.o.join("|")] = v; });
    const SETS = {}; (D.sets || []).forEach(s => { SETS[s.size] = s; });
    const owner = D.owner && new URLSearchParams(location.search).has("owner") ? D.owner : null;
    const fmt = c => "$" + (c / 100).toFixed(2);
    let size = D.sizes.includes(D.defaultSize) ? D.defaultSize : D.sizes[Math.min(2, D.sizes.length - 1)];
    const choice = {}; PANELS.forEach(p => { choice[p.key] = MEDIA ? "none" : p.def; });
    const COLS = D.colours || COLOURS;
    const BASE_COLOUR = D.baseColour || "Satin Black";
    let colour = COLS.find(c => c.name === (D.defaultColour || BASE_COLOUR)) || COLS[0];
    // any colour but the base is a premium: one "colour premium" line per panel (D.colourPremium = {id, price})
    const leadWeeks = () => (D.leadWeeks || 2) + (premiumEach() ? (D.customColourExtraWeeks ?? 1) : 0);
    const premiumEach = () => colour.name !== BASE_COLOUR && D.colourPremium ? D.colourPremium.price : 0;

    const variant = (k, style) => V[[size, PANELS.find(p => p.key === k).label, STYLE_NAME[style]].join("|")];
    const lines = () => PANELS.filter(p => choice[p.key] !== "none").map(p => ({ p, style: choice[p.key], v: variant(p.key, choice[p.key]) }));
    const isStandard = () => PANELS.every(p => choice[p.key] === p.def);
    const buildString = () => size + ":" + PANELS.map(p => `${p.key}=${choice[p.key]}`).join(",") + `,colour=${colour.name}`;

    root.innerHTML += `
      <div class="cpb__grid">
        <div class="cpb__visual">
          <div class="cpb__stage" hidden>
            <div class="cpb__views"><button type="button" data-v="front">Front</button><button type="button" data-v="back">Back</button><button type="button" data-v="spin" aria-pressed="true">Spin</button></div>
            <div class="cpb__frame-colour"><button type="button" data-f="Black" aria-pressed="true">Black frame</button><button type="button" data-f="Silver">Silver frame</button></div>
            <p class="cpb__stage-cap"></p>
          </div>
          <svg class="cpb__iso" viewBox="0 0 320 300" role="img" aria-label="Preview of your rack with the chosen panels"></svg>
          <div class="cpb__flats" aria-hidden="true"></div>
          <ul class="cpb__specs">
            <li>2 mm 5005 aluminium, CNC cut and powder coated in Adelaide</li>
            <li>1.5 mm clearance a side, with printed shims to fine-tune the fit</li>
            <li>M3 button heads, drop-in T-nuts and grommets included</li>
          </ul>
        </div>
        <div class="cpb__form">
          <fieldset class="cpb__sizes"><legend class="cpb__label">Rack height</legend><div class="cpb__pills"></div></fieldset>
          <fieldset class="cpb__colours"><legend class="cpb__label">Colour <span class="cpb__colour-name"></span></legend><div class="cpb__swatches"></div></fieldset>
          <div class="cpb__label cpb__label--panels">Panels <span class="cpb__presets"></span></div>
          <div class="cpb__panels"></div>
          <div class="cpb__summary" aria-live="polite"></div>
          <div class="cpb__fit" role="note" hidden>
            <strong>Heads up: these plates are full-set size</strong>
            <p>Every plate is made to overlap its neighbours in a full set of 6, so you can add the rest later and they'll fit. Until the set is complete, a plate on its own sits about 2 mm past the frame on any edge without a neighbouring plate.</p>
            <label><input type="checkbox" class="cpb__fit-ok"> I understand: on their own, these plates sit about 2 mm proud of the frame edge</label>
          </div>
          <button type="button" class="cpb__add button button--primary"></button>
          <p class="cpb__msg" role="status"></p>
          <div class="cpb__owner" hidden></div>
        </div>
      </div>`;
    const $ = s => root.querySelector(s);

    function presets() {
      const el = $(".cpb__presets"); el.innerHTML = "";
      [["Standard set", () => PANELS.forEach(p => { choice[p.key] = p.def; })],
       ["All vented", () => PANELS.forEach(p => { choice[p.key] = p.vent ? "vented" : "plain"; })],
       ["Clear", () => PANELS.forEach(p => { choice[p.key] = "none"; })]].forEach(([t, fn]) => {
        const b = document.createElement("button"); b.type = "button"; b.className = "cpb__link"; b.textContent = t;
        b.onclick = () => { fn(); render(); }; el.appendChild(b);
      });
    }

    function pills() {
      const el = $(".cpb__pills"); el.innerHTML = "";
      D.sizes.forEach(s => {
        const b = document.createElement("button"); b.type = "button"; b.className = "cpb__pill"; b.textContent = s;
        b.setAttribute("aria-pressed", s === size);
        b.onclick = () => { size = s; render(); };
        el.appendChild(b);
      });
    }

    function swatches() {
      const el = $(".cpb__swatches"); el.innerHTML = "";
      COLS.forEach(c => {
        const b = document.createElement("button"); b.type = "button"; b.className = "cpb__swatch cpb__swatch--" + c.finish;
        b.style.setProperty("--sw", c.hex); b.title = `${c.name} · ${FINISH[c.finish].label}`;
        b.setAttribute("aria-label", b.title); b.setAttribute("aria-pressed", c === colour);
        b.onclick = () => { colour = c; render(); };
        el.appendChild(b);
      });
      $(".cpb__colour-name").textContent = `${colour.name} · ${FINISH[colour.finish].label}` +
        (VIEW ? "" : premiumEach() ? ` · +${fmt(premiumEach())} a panel` : " · included");
    }

    function panels() {
      const el = $(".cpb__panels"); el.innerHTML = "";
      PANELS.forEach(p => {
        const row = document.createElement("div"); row.className = "cpb__row";
        const opts = [["none", "None"], ["plain", p.vent ? "Plain" : "Include"]];
        if (p.vent) opts.push(["vented", "Vented"]);
        row.innerHTML = `<div class="cpb__pname">${p.label}<small>${p.note}</small></div><div class="cpb__seg" role="group" aria-label="${p.label}"></div>`;
        const seg = row.querySelector(".cpb__seg");
        opts.forEach(([val, t]) => {
          const v = val === "none" ? null : variant(p.key, val);
          const b = document.createElement("button"); b.type = "button";
          b.innerHTML = `<span>${t}</span>${v && !VIEW ? `<em>${fmt(v.price)}</em>` : ""}`;
          b.setAttribute("aria-pressed", choice[p.key] === val);
          if (!VIEW && val !== "none" && !v) { b.disabled = true; b.title = "Not available right now"; }
          b.onclick = () => { choice[p.key] = val; render(); };
          seg.appendChild(b);
        });
        el.appendChild(row);
      });
    }

    function totals() {
      const L = lines();
      const sub = L.reduce((t, l) => t + (l.v ? l.v.price : 0), 0);
      const set = isStandard() && SETS[size] ? SETS[size] : null;
      const full = L.length === PANELS.length;
      let total = sub, saving = 0, how = "";
      if (set) { total = set.price; saving = sub - set.price; how = "Standard set price"; }
      else if (full && D.setDiscountPct) { saving = Math.round(sub * D.setDiscountPct / 100); total = sub - saving; how = `Full set: ${D.setDiscountPct}% off`; }
      const premium = premiumEach() * L.length;
      total += premium;
      return { L, sub, total, saving, how, set, full, premium };
    }

    function summary() {
      if (VIEW) {          // viewer page: rack specs, no prices or cart
        const [oh, rail, holes] = RACK[size];
        $(".cpb__summary").innerHTML = `<div class="cpb__line cpb__line--total"><span>${size} TEN-FOUR</span><span></span></div>` +
          [["Outside height", `${oh} mm`], ["Rail length", `${rail} mm`], ["Holes per rail", holes], ["Rack units", size], ["Panels shown", `${lines().length} of 6`]]
            .map(([k, v]) => `<div class="cpb__line"><span>${k}</span><span>${v}</span></div>`).join("");
        $(".cpb__fit").hidden = true; $(".cpb__add").hidden = true;
        return;
      }
      const t = totals();
      let h = t.L.map(l => `<div class="cpb__line"><span>${l.p.label}${l.style === "vented" ? " · vented" : ""}</span><span>${l.v ? fmt(l.v.price) : "–"}</span></div>`).join("");
      if (t.saving > 0) h += `<div class="cpb__line cpb__line--save"><span>${t.how}</span><span>−${fmt(t.saving)}</span></div>`;
      else if (t.L.length && D.setDiscountPct) h += `<div class="cpb__line cpb__line--hint"><span>Choose all 6 panels to save ${D.setDiscountPct}%</span><span></span></div>`;
      if (t.premium) h += `<div class="cpb__line"><span>${colour.name} powder coat · ${t.L.length} × ${fmt(premiumEach())}</span><span>+${fmt(t.premium)}</span></div>`;
      h += `<div class="cpb__line cpb__line--hint"><span>Made to order: ships in about ${leadWeeks()} weeks${premiumEach() ? " (custom colour)" : ""}</span><span></span></div>`;
      h += `<div class="cpb__line cpb__line--total"><span>${size} cover plates <small>incl. GST</small></span><span>${fmt(t.total)}</span></div>`;
      $(".cpb__summary").innerHTML = t.L.length ? h : `<p class="cpb__empty">Pick at least one panel.</p>`;
      // part sets: plates are full-set size, so they overhang until the set is complete (owner: "make it SUPER clear")
      const partial = t.L.length > 0 && !t.full;
      $(".cpb__fit").hidden = !partial;
      const add = $(".cpb__add");
      const soldOut = t.set ? !t.set.available : t.L.some(l => !l.v || !l.v.available);
      add.disabled = !t.L.length || soldOut || (partial && !$(".cpb__fit-ok").checked);
      add.textContent = !t.L.length ? "Add to cart" : soldOut ? `Sold out · ${fmt(t.total)}` : `Add to cart · ${fmt(t.total)}`;
      if (owner) ownerView(t);
    }

    function iso() {
      // isometric-ish rack from the front right, frame drawn as lines, chosen panels filled
      const on = k => choice[k] !== "none", vent = k => choice[k] === "vented";
      const h = 40 + FRAME_H[size] * 0.33, w = 150, d = 90, x0 = 60, y0 = 270, dx = d * 0.62, dy = d * 0.42;
      const P = (x, y) => `${x.toFixed(1)},${y.toFixed(1)}`;
      const quad = (pts, cls) => `<polygon class="${cls}" points="${pts.map(p => P(...p)).join(" ")}"/>`;
      const fl = [x0, y0], fr = [x0 + w, y0], flt = [x0, y0 - h], frt = [x0 + w, y0 - h];
      const br = [x0 + w + dx, y0 - dy], brt = [x0 + w + dx, y0 - h - dy], blt = [x0 + dx, y0 - h - dy], bl = [x0 + dx, y0 - dy];
      let s = "";
      // hidden faces first (rear, left, bottom) as ghosted when chosen
      if (on("rear")) s += quad([bl, br, brt, blt], "cpb-face cpb-face--back");
      if (on("side-left")) s += quad([fl, bl, blt, flt], "cpb-face cpb-face--back");
      if (on("bottom")) s += quad([fl, fr, br, bl], "cpb-face cpb-face--back");
      s += `<g class="cpb-frame">${[[fl, bl], [bl, br], [bl, blt]].map(([a, b]) => `<line x1="${a[0]}" y1="${a[1]}" x2="${b[0]}" y2="${b[1]}"/>`).join("")}</g>`;
      if (on("side-right")) s += quad([fr, br, brt, frt], "cpb-face");
      if (on("top")) s += quad([flt, frt, brt, blt], "cpb-face cpb-face--top");
      if (on("front-surround")) {
        s += quad([fl, fr, frt, flt], "cpb-face cpb-face--front");
        s += `<rect class="cpb-window" x="${x0 + 14}" y="${y0 - h + 11}" width="${w - 28}" height="${h - 22}"/>`;
      }
      // vents: honeycomb hint drawn as a dotted ellipse in the face's plane
      const hex = (cx, cy, rx, ry) => `<ellipse class="cpb-vent" cx="${cx}" cy="${cy}" rx="${rx}" ry="${ry}"/>`;
      if (vent("top")) s += hex(x0 + w / 2 + dx / 2, y0 - h - dy / 2, 26, 13);
      if (vent("side-right")) s += hex(x0 + w + dx / 2, y0 - h * 0.78 - dy / 2, 13, 19);
      if (vent("rear") && on("rear")) s += hex(x0 + w / 2 + dx, y0 - h * 0.7 - dy, 18, 14).replace("cpb-vent", "cpb-vent cpb-vent--back");
      s += `<g class="cpb-frame">${[[fl, fr], [fr, frt], [frt, flt], [flt, fl], [fr, br], [br, brt], [brt, frt], [brt, blt], [blt, flt]].map(([a, b]) => `<line x1="${a[0]}" y1="${a[1]}" x2="${b[0]}" y2="${b[1]}"/>`).join("")}</g>`;
      s += `<text class="cpb-caption" x="160" y="292" text-anchor="middle">${size} · ${lines().length} of 6 panels</text>`;
      $(".cpb__iso").innerHTML = s;
    }

    function flats() {
      // every chosen panel, flat and to scale, with its holes and vent
      const dm = dims(size), sc = 0.16;
      $(".cpb__flats").innerHTML = lines().map(({ p, style }) => {
        const [W, H] = dm[p.key], w = W * sc, h = H * sc;
        let s = `<rect class="cpb-plate" style="fill:${colour.hex}" x="0" y="0" width="${w}" height="${h}"/>`;
        if (p.key === "front-surround") s += `<rect class="cpb-hole" x="${22.25 * sc}" y="${23.5 * sc}" width="${(W - 44.5) * sc}" height="${(H - 47) * sc}"/>`;
        if (p.key === "rear") [102.1, 203.4].forEach(x => { s += `<circle class="cpb-hole" cx="${x * sc}" cy="${(H - 75.75) * sc}" r="${35 * sc}"/>`; });
        if (style === "vented") {
          const cy = p.key === "rear" || p.key.startsWith("side") ? 68 : H / 2, cx = W / 2;
          s += `<circle class="cpb-honey" cx="${cx * sc}" cy="${cy * sc}" r="${38 * sc}"/>`;
        }
        if (p.key === "side-left") s += `<rect class="cpb-logo" x="${15 * sc}" y="${(H - 30) * sc}" width="${50 * sc}" height="${12 * sc}"/>`;
        return `<figure><svg viewBox="-1 -1 ${w + 2} ${h + 2}" width="${w + 2}" height="${h + 2}">${s}</svg><figcaption>${p.label}${style === "vented" ? " (V)" : ""}<br>${W.toFixed(0)} × ${H.toFixed(0)}</figcaption></figure>`;
      }).join("");
    }

    // ---------- owner view (local preview only: costs, nest, CNC time) ----------
    function pack(parts, W, H, m, g) {
      let free = [[m, m, W - 2 * m + g, H - 2 * m + g]]; const placed = [];
      for (const [key, w0, h0] of [...parts].sort((a, b) => b[1] * b[2] - a[1] * a[2])) {
        let best = null;
        for (const [w, h] of [[w0 + g, h0 + g], [h0 + g, w0 + g]])
          for (const [fx, fy, fw, fh] of free)
            if (w <= fw + 1e-9 && h <= fh + 1e-9) {
              const sc = [Math.min(fw - w, fh - h), Math.max(fw - w, fh - h)];
              if (!best || sc[0] < best[0][0] || (sc[0] === best[0][0] && sc[1] < best[0][1])) best = [sc, fx, fy, w, h];
            }
        if (!best) return null;
        const [, x, y, w, h] = best; placed.push([key, x, y, w - g, h - g]);
        const nf = [];
        for (const [fx, fy, fw, fh] of free) {
          if (x >= fx + fw || x + w <= fx || y >= fy + fh || y + h <= fy) { nf.push([fx, fy, fw, fh]); continue; }
          if (x > fx) nf.push([fx, fy, x - fx, fh]);
          if (x + w < fx + fw) nf.push([x + w, fy, fx + fw - x - w, fh]);
          if (y > fy) nf.push([fx, fy, fw, y - fy]);
          if (y + h < fy + fh) nf.push([fx, y + h, fw, fy + fh - y - h]);
        }
        free = nf.filter((r, i) => !nf.some((o, j) => j !== i && r[0] >= o[0] && r[1] >= o[1] && r[0] + r[2] <= o[0] + o[2] && r[1] + r[3] <= o[1] + o[3] && !r.every((v, q) => v === o[q])));
      }
      return placed;
    }

    function ownerView(t) {
      const A = owner.A, el = $(".cpb__owner"); el.hidden = false;
      const cost = t.L.reduce((s, l) => s + owner.cost[`${size}|${l.p.key}|${l.style}`], 0) + (t.full ? A.box_set : A.box_single * t.L.length)
        + (t.premium ? (owner.colourCostPerPanel || 0) * t.L.length : 0);
      const total = t.total / 100, exGst = A.gst_registered ? total / 1.1 : total, fees = total * A.fees_pct / 100, profit = exGst - cost - fees;
      const cnc = t.L.reduce((s, l) => s + owner.cnc[`${size}|${l.p.key}|${l.style}`], 0);
      const anyVent = t.L.some(l => l.style === "vented");
      const [SW, SH] = A.sheet_mm, dm = dims(size);
      const placed = t.L.length ? pack(t.L.map(l => [l.p.key, ...dm[l.p.key]]), SW, SH, A.edge_margin, A.part_gap) : [];
      const sc = 300 / SW;
      const nest = `<svg viewBox="0 0 ${SW * sc} ${SH * sc}" class="cpb__nest"><rect x="0" y="0" width="${SW * sc}" height="${SH * sc}" class="cpb-sheet"/>` +
        (placed || []).map(([k, x, y, w, h]) => `<rect class="cpb-part" x="${x * sc}" y="${(SH - y - h) * sc}" width="${w * sc}" height="${h * sc}"/>`).join("") + `</svg>`;
      const used = (placed || []).reduce((s, [, , , w, h]) => s + w * h, 0) / (SW * SH);
      el.innerHTML = `<div class="cpb__label">Owner view <small>(?owner, local only)</small></div>
        <div class="cpb__line"><span>Cost to make (ex GST)</span><span>$${cost.toFixed(2)}</span></div>
        <div class="cpb__line"><span>Card fees ${A.fees_pct}%</span><span>$${fees.toFixed(2)}</span></div>
        <div class="cpb__line ${profit < 0 ? "cpb__neg" : ""}"><span>Profit</span><span>$${profit.toFixed(2)} · ${(100 * profit / Math.max(exGst, 1)).toFixed(0)}%</span></div>
        <div class="cpb__label" style="margin-top:12px">Nest on a ${SW} × ${SH} sheet <small>(${A.edge_margin} mm edge and gap)</small></div>
        ${nest}
        <div class="cpb__line"><span>Sheet used by this order</span><span>${(100 * used).toFixed(0)}%</span></div>
        <div class="cpb__line"><span>CNC program run time</span><span>~${Math.round(cnc + (anyVent ? A.tool_change_min : 0))} min</span></div>
        <div class="cpb__line"><span>+ load, zero, unload</span><span>~${A.sheet_setup_min} min</span></div>
        <div class="cpb__label" style="margin-top:12px">Order string (saved on the order as <code>_build</code>)</div>
        <pre class="cpb__pre">${buildString()}</pre>
        <div class="cpb__label">Nest it and write the programs</div>
        <pre class="cpb__pre">python -I cover-plates/pricing-v2/nest_order_v2.py "&lt;logo.svg&gt;" orders/&lt;order no&gt; "${buildString()}"</pre>`;
    }

    async function addToCart() {
      const t = totals(), msg = $(".cpb__msg"), btn = $(".cpb__add");
      const build = buildString(), ref = "CP-" + Date.now().toString(36).toUpperCase();
      const partial = !t.full;
      const props = { "Build": `${size} cover plates (${ref})`, "Colour": `${colour.name} (${FINISH[colour.finish].label.toLowerCase()})`, "Ships in": `about ${leadWeeks()} weeks`, _build: build, _ref: ref };
      if (partial) props["Fit"] = "Full-set size: sits about 2 mm proud of the frame until the set is complete (customer ticked to confirm)";
      const items = t.set ? [{ id: t.set.id, quantity: 1, properties: props }]
        : t.L.map(l => ({ id: l.v.id, quantity: 1, properties: props }));
      if (t.premium) items.push({ id: D.colourPremium.id, quantity: t.L.length, properties: props });
      if (D.preview) { msg.textContent = "Preview only: this would go to /cart/add.js"; console.log({ items }); $(".cpb__owner").hidden || ($(".cpb__owner").innerHTML += `<pre class="cpb__pre">${JSON.stringify({ items }, null, 1)}</pre>`); return; }
      btn.disabled = true; msg.textContent = "Adding…";
      try {
        const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart/add.js",
          { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items }) });
        if (!r.ok) throw new Error((await r.json()).description || "Couldn't add to cart");
        location.href = D.cartUrl || "/cart";
      } catch (e) { msg.textContent = e.message; btn.disabled = false; }
    }

    // ---------- 3D view: the site viewer's rack model + real plate models (falls back to the drawing) ----------
    const M = D.models3d, V3 = {};
    async function start3d() {
      if (!M || !window.WebGLRenderingContext) return;
      const CDN = "https://cdn.jsdelivr.net/npm/three@0.160.0/";
      try {
        const [THREE, { GLTFLoader }, { OrbitControls }, { RoomEnvironment }] = await Promise.all([
          import(CDN + "+esm"), import(CDN + "examples/jsm/loaders/GLTFLoader.js/+esm"),
          import(CDN + "examples/jsm/controls/OrbitControls.js/+esm"), import(CDN + "examples/jsm/environments/RoomEnvironment.js/+esm")]);
        const stage = $(".cpb__stage");
        const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
        renderer.outputColorSpace = THREE.SRGBColorSpace;
        renderer.toneMapping = THREE.ACESFilmicToneMapping; renderer.toneMappingExposure = 1.0;
        renderer.domElement.setAttribute("role", "img");
        renderer.domElement.setAttribute("aria-label", "3D preview of your rack with the chosen cover plates. Drag to turn it.");
        stage.prepend(renderer.domElement);
        const scene = new THREE.Scene();
        scene.environment = new THREE.PMREMGenerator(renderer).fromScene(new RoomEnvironment(), 0.04).texture;
        scene.environmentIntensity = 1.0;
        const camera = new THREE.PerspectiveCamera(28, 1, 1, 100000);
        // no directional lights: even, soft studio light from all round (environment + ambient)
        scene.add(camera);
        scene.add(new THREE.AmbientLight(0xffffff, 0.35));
        const key = new THREE.DirectionalLight(0xffffff, 1.4); key.position.set(0.4, 0.25, 1); camera.add(key);
        key.target.position.set(0, 0, -1); camera.add(key.target);
        const controls = new OrbitControls(camera, renderer.domElement);
        controls.enableDamping = true;
        // left drag turns, wheel zooms, middle (wheel) click drags to pan
        controls.mouseButtons = { LEFT: THREE.MOUSE.ROTATE, MIDDLE: THREE.MOUSE.PAN, RIGHT: THREE.MOUSE.PAN };
        controls.enableZoom = true; controls.zoomToCursor = false;
        // keep the camera outside the rack however it is panned: zoom stops at the model's bounding sphere
        let hull = null;
        controls.addEventListener("change", () => {
          if (!hull) return;
          hull.box.clampPoint(controls.target, controls.target);
          controls.minDistance = hull.r * 1.15 + controls.target.distanceTo(hull.c);
        });
        const calm = matchMedia("(prefers-reduced-motion: reduce)").matches;
        controls.autoRotate = !calm; controls.autoRotateSpeed = 1.1;
        // soft floor shadow
        const cv = document.createElement("canvas"); cv.width = cv.height = 128;
        const g = cv.getContext("2d"), grd = g.createRadialGradient(64, 64, 4, 64, 64, 64);
        grd.addColorStop(0, "rgba(0,0,0,.35)"); grd.addColorStop(1, "rgba(0,0,0,0)"); g.fillStyle = grd; g.fillRect(0, 0, 128, 128);
        const floor = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), new THREE.MeshBasicMaterial({ map: new THREE.CanvasTexture(cv), transparent: true, depthWrite: false }));
        floor.rotation.x = -Math.PI / 2; scene.add(floor);
        const loader = new GLTFLoader(), cache = {};
        const COAT = new THREE.MeshPhysicalMaterial({ metalness: 0, side: THREE.DoubleSide });
        const paintCoat = () => {
          const f = FINISH[colour.finish];
          COAT.color.set(colour.hex); COAT.roughness = f.roughness; COAT.clearcoat = f.clearcoat; COAT.clearcoatRoughness = f.clearcoatRoughness;
          COAT.needsUpdate = true;
        };
        const ETCH = new THREE.MeshStandardMaterial({ color: 0xc9ccd2, metalness: 0.95, roughness: 0.28 });
        // anodised aluminium extrusion; rails, brackets and feet black
        const FIN = { Black: { color: 0x1b1c1f, metalness: 0.55, roughness: 0.42 }, Silver: { color: 0xc6c9ce, metalness: 0.9, roughness: 0.32 } };
        const DARK = new THREE.MeshStandardMaterial({ color: 0x17181a, metalness: 0.3, roughness: 0.5 });
        const EXTR = new THREE.MeshStandardMaterial(FIN.Black);
        // M3 button head screws, black oxide
        const SCREW = new THREE.MeshStandardMaterial({ color: 0x111214, metalness: 0.3, roughness: 0.45 });
        const EDGE = new THREE.LineBasicMaterial({ color: 0x9aa2ae, transparent: true, opacity: 0.25 });
        let cur = null, seq = 0, view = "spin";
        const load = url => {
          if (!cache[url]) cache[url] = loader.loadAsync(url).then(gl => {
            const m = gl.scene, raw = new THREE.Box3().setFromObject(m).getSize(new THREE.Vector3());
            if (Math.max(raw.x, raw.y, raw.z) < 10) m.scale.setScalar(1000);
            // light CAD-style edge lines on every part (children of the mesh, so they hide with it)
            const meshes = []; m.traverse(o => { if (o.isMesh) meshes.push(o); });
            meshes.forEach(o => o.add(new THREE.LineSegments(new THREE.EdgesGeometry(o.geometry, 25), EDGE)));
            // packed (quantised) meshes get wrong bounds, so close up three.js would cull faces that are on screen
            meshes.forEach(o => { o.frustumCulled = false; });
            return m;
          });
          return cache[url];
        };
        const tag = o => { for (let q = o; q; q = q.parent) { const mm = /^([a-z-]+)\|(plain|vented|screws)(\|logo)?/.exec(q.name || ""); if (mm) return mm; } return null; };
        function paint() {
          if (!cur) return;
          paintCoat();
          cur.rack.traverse(o => { if (o.isMesh) o.material = /Extrusion/i.test((o.parent && o.parent.name) || o.name) ? EXTR : DARK; });
          cur.plates.traverse(o => {
            if (!o.isMesh) return;
            const t = tag(o); if (!t) return;
            o.material = t[2] === "screws" ? SCREW : t[3] ? ETCH : COAT;
            o.visible = t[2] === "screws" ? choice[t[1]] !== "none" : choice[t[1]] === t[2];
          });
          $(".cpb__stage-cap").textContent = MEDIA ? `${size} TEN-FOUR · drag to turn` : `${size} · ${lines().length} of 6 panels · drag to turn`;
        }
        function frame(v) {
          // rack plus every plate (hidden ones too), so the zoom stop clears the plates on the outside
          const box = new THREE.Box3().setFromObject(cur.rack).expandByObject(cur.plates), c = box.getCenter(new THREE.Vector3()), sz = box.getSize(new THREE.Vector3());
          floor.position.set(c.x, box.min.y - 0.5, c.z); floor.scale.setScalar(Math.max(sz.x, sz.z) * 1.9);
          const r = sz.length() / 2, vh = THREE.MathUtils.degToRad(camera.fov / 2), hh = Math.atan(Math.tan(vh) * camera.aspect);
          const dist = r / Math.sin(Math.min(vh, hh)) * 1.0;
          const dirs = { spin: [1.1, 0.6, 1.4], front: [0.35, 0.28, 1], back: [-0.5, 0.3, -1] };
          camera.position.copy(c).addScaledVector(new THREE.Vector3(...dirs[v]).normalize(), dist);
          // zoom stops just outside the rack, so nothing is ever cut away (hide panels to see inside)
          hull = { box, c, r }; controls.minDistance = r * 1.15; controls.maxDistance = dist * 3;
          camera.near = r * 0.02; camera.far = dist * 100; camera.updateProjectionMatrix();
          controls.target.copy(c); controls.autoRotate = v === "spin" && !calm; controls.update();
          stage.querySelectorAll("[data-v]").forEach(b => b.setAttribute("aria-pressed", String(b.dataset.v === v)));
        }
        V3.update = async () => {
          const mine = ++seq, s = size;
          let rack, plates;
          try { [rack, plates] = await Promise.all([load(M.rack[s]), load(M.plates[s])]); }
          catch (e) {            // this size has no model: show the drawing for it, keep 3D for the others
            delete cache[M.rack[s]]; delete cache[M.plates[s]];
            if (mine === seq) { stage.hidden = true; $(".cpb__iso").toggleAttribute("hidden", false); }
            console.warn("No 3D model for " + s, e); return;
          }
          if (mine !== seq) return;
          stage.hidden = false; $(".cpb__iso").toggleAttribute("hidden", true);
          if (!cur || cur.size !== s) {
            if (cur) { scene.remove(cur.rack); scene.remove(cur.plates); }
            cur = { size: s, rack, plates }; scene.add(rack); scene.add(plates); frame(view);
          }
          paint();
        };
        V3.finish = f => {
          EXTR.color.setHex(FIN[f].color); EXTR.metalness = FIN[f].metalness; EXTR.roughness = FIN[f].roughness;
          stage.querySelectorAll("[data-f]").forEach(b => b.setAttribute("aria-pressed", String(b.dataset.f === f)));
        };
        stage.querySelectorAll("[data-v]").forEach(b => { b.onclick = () => { view = b.dataset.v; if (cur) frame(view); }; });
        stage.querySelectorAll("[data-f]").forEach(b => { b.onclick = () => V3.finish(b.dataset.f); });
        renderer.domElement.addEventListener("mousedown", e => { if (e.button === 1) e.preventDefault(); }); // no browser autoscroll on middle click
        renderer.domElement.addEventListener("pointerdown", () => { controls.autoRotate = false; stage.querySelector("[data-v=spin]").setAttribute("aria-pressed", "false"); });
        const resize = () => { const w = stage.getBoundingClientRect().width; renderer.setSize(w, w * 0.92, false); camera.aspect = 1 / 0.92; camera.updateProjectionMatrix(); };
        new ResizeObserver(resize).observe(stage);
        stage.hidden = false; resize();
        await V3.update();
        if (MEDIA) {
          V3.finish(D.frame === "Silver" ? "Silver" : "Black");
          const box = root.closest("[data-cpb-media]") || root, to = D.mediaTarget && document.querySelector(D.mediaTarget);
          if (to && cur) { [...to.children].forEach(c => { c.hidden = true; }); to.appendChild(box); box.hidden = false; }
        }
        renderer.setAnimationLoop(() => { controls.update(); renderer.render(scene, camera); });
      } catch (e) {
        console.warn("Cover plate 3D view unavailable, showing the drawing", e);
        $(".cpb__stage").hidden = true; $(".cpb__iso").toggleAttribute("hidden", false);
      }
    }

    function render() { pills(); swatches(); panels(); summary(); iso(); flats(); if (V3.update) V3.update(); }
    $(".cpb__add").onclick = addToCart;
    $(".cpb__fit-ok").onchange = summary;

    // on the rack page, follow the rack's own Rack Height picker
    if (D.followRackHeight) document.addEventListener("change", e => {
      const v = e.target && e.target.value;
      if (e.target.name && /rack height/i.test(e.target.name) && D.sizes.includes(v)) { size = v; render(); }
    });
    if (D.followRackHeight) document.addEventListener("change", e => {
      if (e.target.name && /colou?r/i.test(e.target.name) && V3.finish && /^(Black|Silver)$/.test(e.target.value)) V3.finish(e.target.value);
    });
    presets(); render(); start3d();
  }

  const start = () => document.querySelectorAll("[data-cpb]:not([data-cpb-ready])").forEach(r => { r.setAttribute("data-cpb-ready", ""); init(r); });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
  document.addEventListener("shopify:section:load", start);
})();
